// extracted by mini-css-extract-plugin
module.exports = {"search":"AdminSearchPage_search__0s3nT","paginationContainer":"AdminSearchPage_paginationContainer__SmCEt","tabs":"AdminSearchPage_tabs___7USM"};